module.exports = __webpack_public_path__ + "static/media/abrar1.69aac5f2.jpg";